import { render, staticRenderFns } from "./RuleType.vue?vue&type=template&id=36b52603&scoped=true&"
import script from "./RuleType.vue?vue&type=script&lang=js&"
export * from "./RuleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b52603",
  null
  
)

export default component.exports